var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3186_78005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2239 11.9033L16.2241 10.1712C15.4664 7.71606 17.4233 5.09229 20.0011 5.13401C25.2141 5.33176 25.2132 12.8071 20.001 13.0042C18.8851 13.0042 17.877 12.5365 17.1601 11.7877L14.5913 13.2708L20.3307 19.0102C22.238 19.1692 23.7623 20.6935 23.9213 22.6008L27.9058 26.5852C40.7112 11.2288 20.7544 -8.70671 5.41406 4.0935L13.2239 11.9033Z",
    fill: "#5FFEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 24.9984C20.9977 24.9984 21.8321 24.2887 22.0255 23.3479L19.5838 20.9062C17.1775 21.4568 17.5105 24.9355 20.0005 24.9984Z",
    fill: "#5FFEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1602 20.2124C17.4454 19.9145 17.7773 19.662 18.1433 19.4649L12.9166 14.2383L11.7734 14.8983C11.983 15.5922 11.983 16.4087 11.7734 17.1026L17.1602 20.2124Z",
    fill: "#5FFEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0662 9.06914C22.0662 7.92926 21.1388 7.00195 19.999 7.00195C17.2604 7.10587 17.2611 11.0329 19.999 11.1363C21.1388 11.1363 22.0662 10.209 22.0662 9.06914Z",
    fill: "#5FFEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92969 16.0008C5.92969 17.1407 6.85706 18.068 7.99688 18.068C10.7355 17.9641 10.7348 14.0371 7.99688 13.9336C6.857 13.9336 5.92969 14.8609 5.92969 16.0008Z",
    fill: "#5FFEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4689 24.7892C21.1555 28.871 15.0216 26.4091 16.2246 21.8281L10.8378 18.7182C8.43514 21.2615 4.05606 19.5376 4.06179 15.9995C4.05606 12.4614 8.43583 10.7374 10.8378 13.2808L11.5496 12.8699L4.09373 5.41406C-8.71171 20.7705 11.2452 40.706 26.5855 27.9058L23.4689 24.7892Z",
    fill: "#5FFEE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3186_78005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.bd8a3f53f6b418d469f866745575e5e2.svg";
export { ForwardRef as ReactComponent };